import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function AlertFeedback(props) {
  const { open, setOpen, severity, successCallback, missingFields } = props;

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    if (severity === "success") {
      successCallback();
    }
  };

  const getFormattedFields = () => {
    return missingFields
      .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
      .join(", ")
      .split(", ")
      .map((field, index) => (
        <React.Fragment key={index}>
          {field}
          <br />
        </React.Fragment>
      ));
  };

  const getMessage = () => {
    if (severity === "success") {
      return "Success!";
    } else {
      return (
        <>
          Missing required fields:
          <br />
          {getFormattedFields()}
        </>
      );
    }
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      autoHideDuration={750}
      onClose={handleAlertClose}
    >
      <Alert variant="filled" severity={severity} onClose={handleAlertClose}>
        {getMessage()}
      </Alert>
    </Snackbar>
  );
}
